import { useStaticQuery, graphql } from "gatsby"

export const useSectionAudiancesData = () => {
  const data = useStaticQuery(graphql`
    {
      contentfulSectionAudiances {
        title
        audiancesCards {
          category
          subtitle
          title
          description {
            description
          }
          illustration {
            gatsbyImageData
          }
          link
        }
      }
    }
  `)

  return data.contentfulSectionAudiances
}

